import { Part } from '@entities/Product';

interface WishlistActions {
  id: number;
  name: string;
  code: string;
  announce: string;
}

export interface ProductWishlist {
  id: number;
  rn: number;
  part: number;
  quantity: number;
  allQuantity: number;
  image: string;
  specPrice: number;
  price: number;
  name: string;
  url: string;
  description: string;
  actions: WishlistActions[];
}

export enum CategoryName {
  All = 'Все товары',
  Tyres = 'Шины',
  TruckTires = 'Грузовые шины',
  Disks = 'Диски',
  Akb = 'АКБ',
  Oils = 'Масла',
  Secrets = 'Секретки',
  AutoProduct = 'Автотовары',
}

export const CategoryTypeTitle = {
  [Part.Tyres]: CategoryName.Tyres,
  [Part.TruckTires]: CategoryName.TruckTires,
  [Part.Disks]: CategoryName.Disks,
  [Part.Batteries]: CategoryName.Akb,
  [Part.Oils]: CategoryName.Oils,
  [Part.Secrets]: CategoryName.Secrets,
  [Part.RelatedProducts]: CategoryName.AutoProduct,
};

type CategoryItem = {
  title: CategoryName;
  type?: Part;
  items: ProductWishlist[];
};

export interface ReturnTypeGetListWishlist {
  items: ProductWishlist[];
  totalItems: number;
}

export interface WishlistType {
  id: number;
  totalItems: number;
  totalSpecSum: number;
  totalSum: number;
  isLoaded: boolean;
  isLoadedShared: boolean;
  productCategory: CategoryItem[];
  items: ProductWishlist[];
  shareItems: ProductWishlist[];
}
